module.exports = __webpack_public_path__ + "img/Busbuddy_Hero.cdc8db33.jpg";